import React,{Component} from 'react';
import './AdminHeaderTool.css';
import personsm from '../../../../image/personlg.svg'
import { NavLink, Link } from 'react-router-dom';
class AdminHeaderTool extends Component{
    constructor(){
        super();

        this.state = {
            block: false
        }
    }
    changeColor(){
        this.setState({block: !this.state.block})
     }
     Logout=()=>{
        localStorage.removeItem("KaynuserName")
        localStorage.removeItem("userToken")
        localStorage.removeItem("KaynAdminName")
        localStorage.removeItem("AdminTokenKayn")
        window.location.replace("/Signin")
     }
    render(){
        const Name = localStorage.getItem("KaynAdminName")

        return(
            <div className="AdminHeaderTool text-right px-3">
                <ul className="nav text-center ">
                            <li className="nav-item dropdown select  ">
                                <a className="nav-link text-left m-1  " data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                                <img className="" src={personsm} alt="user kayn" />

                                </a>
                                <div className="dropdown-menu my-0">
                                    <p className="dropdown-item" href="#">Hallo, {Name}</p><hr/>
                                    <p className="dropdown-item" onClick={this.Logout} >Log Out</p>                                   
                                </div>
                            </li>
                </ul>
                
                <button className="d-lg-none d-md-none d-sm-block  btn float-left fixed-top btnminu" onClick={this.changeColor.bind(this)}>&#9776;</button>
                  <div className={"sidebar navAdmin d-lg-none d-md-none d-sm-block  fixed-top shadow "+( this.state.block ? "sidebarblock" : "sidebarnone")} >
                    <ul className="navbar-nav sticky-top text-uppercase iconsnavAdmin">
                    <button className="d-lg-none d-md-none d-sm-block  btn float-left fixed-top btnminu" onClick={this.changeColor.bind(this)}>&#9776;</button>
                   
                    <li className="nav-item ">
                            <NavLink to="/Admin/Orders" className="iconnav "><div className="iconorders mx-auto"></div><p className="fontsize15">Orders</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/Clients" className="iconnav "><div className="iconclient mx-auto"></div><p className="fontsize15">Clients</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/Courier" className="iconnav "><div className=" iconcouriers mx-auto"></div><p className="fontsize15">Courier</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/PendingCourier" className="iconnav "><div className=" iconcouriers mx-auto"></div><p className="fontsize15">Pending Courier</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/Coupons" className="iconnav "><div className="iconcoupons iconcoupons mx-auto"></div><p className="fontsize15">Coupons</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/locations" className="iconnav "><div className="  iconlocations mx-auto"></div><p className="fontsize15">locations</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Admin/FAQ" className="iconnav "><div className=" iconfaq mx-auto"></div><p className="fontsize15">FAQ</p></NavLink>
                        </li>
                    </ul>
                </div>
               
            </div>
        )
    }
}
export default AdminHeaderTool;